export default __webpack_public_path__ + "static/media/Monster-logo.5724af7c.svg";